<template>
  <v-container fluid>
    <v-row>
      <v-col md="6" cols="12" class="pr-1">
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-row>
            <v-col cols="12" class="pb-2">
              <base-material-card
                color="primary"
                icon="mdi-key"
                :title="title"
                inline
                class="px-5 py-4 ml-0"
              >
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <v-text-field
                        label="Nome"
                        outlined
                        :error-messages="errors"
                        v-model="nome"
                        class="pt-5"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-card class="mt-0">
                      <v-toolbar flat>
                        <v-tabs grow>
                          <v-tab>Consulta SQL</v-tab>
                        </v-tabs>
                      </v-toolbar>
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-textarea
                          class="mx-4 ta-padding-c2"
                          v-model="consultaSQL"
                          rows="16"
                          hint="Não insira ';' (ponto e vírgula) no final da query"
                          no-resize
                          clearable
                          background-color="#EEEEEE"
                          placeholder="Escreva aqui sua consulta SQL"
                          :error-messages="errors"
                        />
                      </validation-provider>
                    </v-card>
                  </v-col>
                </v-row>
              </base-material-card>
            </v-col>
          </v-row>
          <v-row>
          <v-col cols="12">
            <v-btn
              color="green"
              min-width="100"
              style="float: right"
              class="mt-n5"
              @click="salvar()"
              :disabled="invalid"
              :loading="loading"
            >
              Salvar
            </v-btn>
          </v-col>
          </v-row>
        </validation-observer>
      </v-col>
      <v-col md="6" cols="12" class="pl-1">
        <v-row>
          <v-col cols="12" class="pb-2">
            <base-material-card
              color="primary"
              icon="mdi-table-eye"
              title="Estrutura das Bases de Dados"
              inline
              class="px-5 py-4 ml-0"
            >
              <estrutura-bases-dados-liberadas class="mt-8" />
            </base-material-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RelatoriosCustomizadosService from '@/services/RelatoriosCustomizadosService';

export default {
  components: {
    EstruturaBasesDadosLiberadas: () => import('@/components/general/GeneralEstruturaBasesDadosLiberadas')
  },

  data: () => ({
    nome: "",
    consultaSQL: '',
    loading: false
  }),

  computed: {
    title() {
      return this.$route.params.id ? "Editando Relatório Customizado" : "Adicionar Relatório Customizado";
    }
  },

  created () {
    this.$route.params.id && this.getRelatorio(this.$route.params.id);
  },

  methods: {
    getRelatorio(id) {
      RelatoriosCustomizadosService.getRelatorio(id)
      .then(response => {
        this.nome = response.data.data.nome;
        this.consultaSQL = response.data.data.codigo_sql;
      })
      .catch(() => this.$toast.error('Erro ao recuperar relatorio customizado.', '',{position:'topRight'}));
    },

    salvar() {
      this.loading = true;

      let sql = this.consultaSQL.trim();
      let data = {
        id: this.$route.params.id ? this.$route.params.id : null,
        nome: this.nome,
        codigo_sql: sql.slice(-1) === ';' ? sql.slice(0, sql.length -1) : sql
      };

      RelatoriosCustomizadosService
        .salvar(data)
        .then(() => {
          this.$toast.success('Relatório customizado salvo com sucesso.', '', { position: 'topRight' });
          this.$router.replace({name: 'Relatórios Histórico'});
        })
        .catch(() => {
          this.$toast.error('Erro ao salvar relatório customizado.', '', { position: 'topRight' });
        })
        .finally(() => this.loading = false);
     },
  }
}
</script>

<style>
  .ta-padding-c2 .v-text-field__slot {
    padding:8px;
  }
  .ta-padding-c2 textarea {
    font-size: 11px !important;
    font-weight: bold !important;
  }
</style>